import { useQuery } from "react-query";
import { getTeachers } from "../services/school/teacher/getTeachers";
import { PagedRequestType } from "../types/PagedResults";
import { Key_teachers } from "../utils/constants";

export const useGetTeachersQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_teachers, JSON.stringify(data)],
    () => getTeachers(data),
    options?{...options}:{}
  );